(() => {
  if (window.FASOLA_SWITCH_FEEDBACK) return;
  window.FASOLA_SWITCH_FEEDBACK = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const style = document.createElement('style');
  style.textContent = `
    html { scroll-behavior: auto !important; }
    .fasola-thumbnails button[aria-current="true"] {
      outline: 3px solid #E2165E; outline-offset: 3px;
      box-shadow: 0 3px 10px #0002;
    }
    .fasola-thumbnails button[aria-busy="true"] { opacity: .55; }
    .fasola-switch-enter { animation: fasola-switch-hop .32s ease-out; }
    .fasola-rubric-enter { animation: fasola-rubric-step .28s ease-out; }
    .fasola-navigation-pending { outline: 3px solid #E2165E !important; outline-offset: 3px; }
    @keyframes fasola-switch-hop {
      0% { transform: translateY(12px) scale(.97); opacity: .45; }
      55% { transform: translateY(-5px) scale(1); opacity: 1; }
      100% { transform: translateY(0) scale(1); opacity: 1; }
    }
    @keyframes fasola-rubric-step {
      from { transform: translateY(18px); opacity: .55; }
      to { transform: translateY(0); opacity: 1; }
    }
    @media (prefers-reduced-motion: reduce) {
      .fasola-switch-enter, .fasola-rubric-enter { animation: none; }
    }`;
  document.head.append(style);
  function pulse(element, className) {
    if (!element || reduced.matches) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
  }
  function topInset() {
    return Math.max(16, ...Array.from(document.querySelectorAll('.atelier-collection-bar-fixed, .atelier-header-wrap .header'))
      .map(el => { const r = el.getBoundingClientRect(); return r.top <= 0 && r.bottom > 0 ? r.bottom + 16 : 16; }));
  }
  function reveal(element, always = false) {
    if (!element) return;
    const rect = element.getBoundingClientRect(), inset = topInset();
    if (always || rect.bottom <= inset || rect.top >= window.innerHeight || rect.top < inset - 40)
      window.scrollTo({ top: Math.max(0, window.scrollY + rect.top - inset), behavior: 'instant' });
  }
  function mark(root, button) {
    root.querySelectorAll('[data-fasola-photo]').forEach(other => {
      if (other === button) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
      other.removeAttribute('aria-busy');
    });
  }
  function mount(root) {
    const photo = root.querySelector('#fasola-photo');
    if (!photo) return;
    const button = Array.from(root.querySelectorAll('[data-fasola-photo]'))
      .find(b => b.dataset.fasolaPhoto === photo.getAttribute('src'));
    if (button) mark(root, button);
  }
  const pending = new WeakMap();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-fasola-photo]');
    if (button) {
      const root = button.closest('#fasola-native-root'), photo = root?.querySelector('#fasola-photo');
      if (!photo || !button.dataset.fasolaPhoto) return;
      mark(root, button);
      if (photo.getAttribute('src') === button.dataset.fasolaPhoto) return;
      const previous = pending.get(photo);
      if (previous) { photo.removeEventListener('load', previous.loaded); photo.removeEventListener('error', previous.failed); }
      button.setAttribute('aria-busy', 'true');
      const loaded = () => {
        if (pending.get(photo)?.loaded !== loaded) return;
        photo.removeEventListener('load', loaded); photo.removeEventListener('error', failed);
        pending.delete(photo); button.removeAttribute('aria-busy');
        reveal(photo.closest('.fasola-product-photo'));
        pulse(photo, 'fasola-switch-enter');
      };
      const failed = () => {
        photo.removeEventListener('load', loaded); photo.removeEventListener('error', failed);
        pending.delete(photo); button.removeAttribute('aria-busy');
      };
      pending.set(photo, { loaded, failed });
      photo.addEventListener('load', loaded); photo.addEventListener('error', failed);
      // The existing gallery handler changes src later in this click event.
      requestAnimationFrame(() => {
        if (photo.getAttribute('src') === button.dataset.fasolaPhoto && photo.complete && photo.naturalWidth) loaded();
      });
      return;
    }
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) {
      if (url.hash && !url.hash.startsWith('#atelier-')) {
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (target) requestAnimationFrame(() => { reveal(target, true); pulse(target, 'fasola-rubric-enter'); });
      }
      return;
    }
    if (!/\/collections\//.test(url.pathname)) return;
    link.classList.add('fasola-navigation-pending');
    try { sessionStorage.setItem('fasola-rubric-destination', JSON.stringify({ path: url.pathname + url.search, at: Date.now() })); } catch {}
  }, true);
  function init() {
    mount(document);
    try {
      const entry = JSON.parse(sessionStorage.getItem('fasola-rubric-destination') || 'null');
      sessionStorage.removeItem('fasola-rubric-destination');
      if (entry && entry.path === location.pathname + location.search && Date.now() - entry.at < 30000) {
        const main = document.getElementById('MainContent');
        requestAnimationFrame(() => { reveal(main, true); pulse(main, 'fasola-rubric-enter'); });
      }
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('pageshow', () => document.querySelectorAll('.fasola-navigation-pending').forEach(el => el.classList.remove('fasola-navigation-pending')));
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
